import { render, staticRenderFns } from "./_page-id.vue?vue&type=template&id=6384db11"
import script from "./_page-id.vue?vue&type=script&lang=js"
export * from "./_page-id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports